export const SUGGESTED_USER_LIST_UPDATE = 'SUGGESTED_USER_LIST_UPDATE';
export const SUGGESTED_USER_UPDATE = 'SUGGESTED_USER_UPDATE';
export const UPDATE_SELECTED_SUGGESTED_USER = 'UPDATE_SELECTED_SUGGESTED_USER';
